// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"2092352d","239":"b65e7f0f","389":"b36a6a38","732":"50d04e38","857":"5488b4b0","977":"9364212a"}[chunkId] + ".chunk.js";
};